const DEFAULT_ITEMS = [
  "ELEVATION 4,633 FT",
  "HUMMINGBIRD CAPITAL OF THE U.S.",
  "FORT HUACHUCA · EST. 1877",
  "MONSOON SEASON · JUL – SEP",
  "ZIP CODES 85635 & 85650",
  "SOUTHEAST ARIZONA · 11 CITIES",
  "365 QUESTIONS · ONE NEW ANSWER DAILY",
  "SAN PEDRO RIPARIAN NCA",
];

export default function Marquee({ items = DEFAULT_ITEMS }) {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden bg-brand-navy-dark border-y border-brand-gold/20 py-3.5 relative">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center text-[11px] sm:text-xs font-mono tracking-[0.25em] text-brand-sand/70">
            <span className="px-6">{item}</span>
            <span className="text-brand-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
